import errorManager from '@/rollbar.js';

const blockVcogList = () => {
  const vcogList = document.querySelectorAll('.cofu_vcog1');
  const vcog1 = document.querySelector('#vcog1');
  const calculatedVcog = document.querySelector('.calcola_cofu_vcog1_input');

  $('.cofu_vcog1').change(function () {
    var vcogEmpty = true;
    $('.cofu_vcog1').each(function () {
      if ($(this).val() !== '') {
        vcogEmpty = false;
        return false;
      }
    });

    if (vcogEmpty) {
      vcog1.removeAttribute('disabled');
    } else {
      vcog1.setAttribute('disabled', 'disabled');
    }
  });

  vcog1.addEventListener('change', function () {
    const vcog1Value = vcog1.value.trim();
    if (vcog1Value === '' || vcog1Value < 1) {
      vcogList.forEach((item) => item.removeAttribute('disabled'));
      calculatedVcog.removeAttribute('disabled');
    } else {
      vcogList.forEach((item) => item.setAttribute('disabled', 'disabled'));
      calculatedVcog.setAttribute('disabled', 'disabled');
    }
  });
};

const init = () => {
  try {
    blockVcogList();
  } catch (error) {
    errorManager(error);
  }
};

window.Vcog1 = {
  init: init,
};
